import { render, staticRenderFns } from "./ChatRobotIcon.vue?vue&type=template&id=a24c5a74&scoped=true"
import script from "./ChatRobotIcon.vue?vue&type=script&lang=js"
export * from "./ChatRobotIcon.vue?vue&type=script&lang=js"
import style0 from "./ChatRobotIcon.vue?vue&type=style&index=0&id=a24c5a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24c5a74",
  null
  
)

export default component.exports